<template>
  <div id="ARmarker" class="ARmarker">
    <Header />

    <div id="header-navi" class="header-navi">
      <h2 class="header-navi__ttl">AR MARKER</h2>
    </div>

    <div class="ARmarker__main">
      <div class="ARmarker__main__figure"><img src="@/assets/images/marker/marker.png" alt="ARmarker"></div>
      <p class="ARmarker__main__text">百貨店店舗で利用できるスマートミラーのAR機能に必要なマーカー画像です。スマートミラーの詳しい使い方は当サービス内ページの<router-link :to="{ name: 'howto' }" class="ARmarker__main__text__link">HOW TO USE</router-link>を御覧ください。</p>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  components: {
    Header,
    Footer
  }
}
</script>

<style lang="scss" scoped>
.header-navi {
  @include customTitle;
}

.ARmarker {
  &__main {
    &__text {
      padding: 0 15px 30px;
      font-size: 14px;
      line-height: 1.5;
      &__link {
        padding: 0 5px;
        color: $blue;
        text-decoration: underline;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Marker.vue